import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
//import store from './store'

import * as Units from './constants/units'

import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT)

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.component('datetime', Datetime);

import { Settings } from 'luxon'
Settings.defaultLocale = 'he'

import { SweetModal } from 'sweet-modal-vue'
Vue.component('sweet-modal', SweetModal)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.config.productionTip = false
Vue.use(Vuex)

router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title(to)
    })
})

import {
    Store
} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

const store = new Vuex.Store({

    plugins: [
        createPersistedState({
            getState: (key) => Cookies.getJSON(key),
            setState: (key, state) => Cookies.set(key, state, {
                expires: 3,
                secure: true
            })
        })
    ],
    state: {
        locale: 'he'
    },
    getters: {
        locale: state => state.locale
    },
    mutations: {
        set_locale(state, locale) {
            console.log('change locale..')
            state.locale = locale
        },
    }
})


import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage, {
    messageOptions: {
        timeout: 6000
    }
});

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import axios from 'axios'
import VueLocalStorage from 'vue-ls'

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios;

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status == 401) {
        console.log('We have 401')
        /*
          flash({
              message: 'You must log in',
              variant: 'success'
          })
          */
        vm.reset_on_401()
        router.push('/login')
        return;
    }
    // Do something with response error
    return Promise.reject(error);
});

let options = {
    namespace: 'atm_',
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
};

Vue.use(VueLocalStorage, options);

import moment from "moment";
import MomentTimezone from "moment-timezone";
moment.locale('he_IL');
Vue.prototype.$moment = moment;

Vue.mixin({

    methods: {
        G_metaOptions: function() {
            return {
                0: 'N',
                1: 'Y'
            }
        },
        hasUnicode: function (str) {
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 127) return true;
            }
            return false;
        },
        getUnit: function (id) {
            console.log(Units)
            var result = Units.filter(obj => {
                return obj.id === id
            })
            return result[0].name
        },
        getI18n: function (key) {
            return this.$t(key)
        },
        goTo: function (target) {
            console.log(target)
        },
        handleTabChange(e) {
            console.log(e)
            this.$router.push('borrowers')
        },
        human_date_time: function (input) {
            return moment(input).format('DD/MM/YYYY HH:mm');
        },
        ls_read_logged_in_as: function () {
            let decoded_jwt = this.$jwt.decode(this.$ls.get('access_token'))
            console.log(decoded_jwt)
            return {
                as: decoded_jwt ? decoded_jwt.logged_in_as : 'guest'
            }
        },
        ls_read_user_name: function () {
            return {
                as: this.$ls.get('user_name')
            }
        },
        ls_read_institute_name: function () {
            return {
                as: this.$ls.get('institute_name')
            }
        },
        ls_auth: function () {
            return this.$ls.get('auth')
        },
        ls_institute_id_for_anon: function () {
            return {
                as: this.$ls.get('ls_institute_id_for_anon')
            }
        },
        auth: function () {
            return {
                headers: {
                    'Authorization': this.$ls.get('access_token')
                }
            }
        },
        authorization: function () {
            return {
                'Authorization': 'Bearer: ' + this.$ls.get('access_token')
            }
        },
        agent: function () {
            return this.$ls.get('agent')
        },
        numberWithCommas: function (x = "0.0") {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        },
        prettyDate: function (input = "2000-01-01T00:00:00", format = "dd/mm/yyyy") {
            var d = new Date(input);
            return dateFormat(d, format);
        },
        b64EncodeUnicode: function (str) {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
        },
        delete_cookie: function (name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },
        reset_on_401: function () {
            console.log('reset_on_401')
            this.$ls.set('logged_in_as', null)
        }
    }
})

const vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')